/** Blob URLs for placeholders (revoke even if DOM node is gone after transaction). */
const uploadIdToBlobUrl = new Map<string, string>();

export function registerUploadPlaceholderBlobUrl(uploadId: string, blobUrl: string): void {
  uploadIdToBlobUrl.set(uploadId, blobUrl);
}

/**
 * Imperative DOM updates for rich upload placeholders (not synced via ProseMirror).
 * Mirrors platform shared/editor/commands/insertFiles.ts progress handling.
 */
export function updateUploadProgressDom(uploadId: string, fractionComplete: number): void {
  const placeholder = document.querySelector(`[data-upload-id="${uploadId}"]`);
  if (!placeholder) return;

  const progressBar = placeholder.querySelector('.bf-circular-progress') as HTMLElement | null;
  if (!progressBar) return;

  const progressValue = progressBar.querySelector('.bf-circular-progress__percentage') as HTMLElement | null;
  if (progressValue) {
    const clamped = Math.min(1, Math.max(0, fractionComplete));
    const pct = Math.round(clamped * 100);
    progressValue.textContent = `${pct}%`;
    progressBar.style.background = `conic-gradient(
      var(--bf-upload-progress-fill, currentColor) ${clamped * 360}deg,
      var(--bf-upload-progress-track, color-mix(in srgb, currentColor 15%, transparent)) 0
    )`;
  }
}

/** Revoke object URL for this upload id (uses registry; safe after decoration is removed). */
export function revokeUploadPlaceholderBlob(uploadId: string): void {
  const url = uploadIdToBlobUrl.get(uploadId);
  if (url) {
    URL.revokeObjectURL(url);
    uploadIdToBlobUrl.delete(uploadId);
  }
}
